import React, { useEffect } from "react";
import ApplicationTypeComponent from "../../components/applicationComponents/applicationType/ApplicationTypeComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";

export default function ApplicationTypePage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Application Category",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <ApplicationTypeComponent disabled={false} />
    </>
  );
}
